/**
 * Analytics Configuration
 * 
 * This file contains configuration settings for both Google Analytics 4 (GA4)
 * and Google Tag Manager (GTM) integrations.
 * 
 * Environment-specific GTM containers are handled automatically based on:
 * - REACT_APP_ENVIRONMENT: 'development', 'qa', 'staging', 'production'
 * - REACT_APP_GTM_CONTAINER_ID: Override container ID via environment variable
 */

// Environment detection
const getEnvironment = () => {
  // Priority: explicit environment variable > NODE_ENV > default
  return process.env.REACT_APP_ENVIRONMENT || 
         process.env.NODE_ENV || 
         'development';
};

// GTM Container ID mapping by environment
const GTM_CONTAINERS = {
  development: 'GTM-PRL8DTXV', // Development/Local (your original container)
  qa: 'GTM-PRL8DTXV', // Your QA GTM Container ID 
  staging: 'GTM-PRL8DTXV', // Optional staging container
  production: 'GTM-PRL8DTXV' // Your Production GTM Container ID
};

// Get the appropriate GTM container ID for current environment
const getGTMContainerId = () => {
  // Allow explicit override via environment variable
  if (process.env.REACT_APP_GTM_CONTAINER_ID) {
    // console.info(`🔧 GTM Container Override: ${process.env.REACT_APP_GTM_CONTAINER_ID}`);
    return process.env.REACT_APP_GTM_CONTAINER_ID;
  }
  
  const environment = getEnvironment();
  const containerId = GTM_CONTAINERS[environment] || GTM_CONTAINERS.development;
  
  // Enhanced debugging - always log in non-test environments
  // if (process.env.NODE_ENV !== 'test') {
  //   console.info(`🏷️  GTM Container Selection:`);
  //   console.info(`   Environment: ${environment}`);
  //   console.info(`   Container ID: ${containerId}`);
  //   console.info(`   Available containers:`, GTM_CONTAINERS);
  //   console.info(`   REACT_APP_ENVIRONMENT: ${process.env.REACT_APP_ENVIRONMENT || 'not set'}`);
  //   console.info(`   NODE_ENV: ${process.env.NODE_ENV || 'not set'}`);
  // }
  
  return containerId;
};

const analyticsConfig = {
  // Google Analytics 4 Configuration
  ga4: {
    // GA4 tracking ID will be loaded from the backend API
    measurementId: null // Set dynamically from /analytics/rest/config
  },

  // Google Tag Manager Configuration
  gtm: {
    containerId: getGTMContainerId(), // Environment-specific GTM Container ID
    options: {
      dataLayer: {
        // Global data layer variables
        environment: getEnvironment(),
        version: '2.0.0',
        platform: 'react',
        app_name: 'analytics-by-liaison',
        build_timestamp: process.env.REACT_APP_BUILD_TIMESTAMP || new Date().toISOString(),
        git_commit: process.env.REACT_APP_GIT_COMMIT || 'unknown'
      },
      auth: process.env.REACT_APP_GTM_AUTH || '', // GTM auth parameter for preview mode
      preview: process.env.REACT_APP_GTM_PREVIEW || '', // GTM preview parameter
      dataLayerName: 'dataLayer' // Default data layer name
    }
  },

  // Event tracking configuration - enable/disable specific events
  events: {
    pageViews: true,
    userDimensions: true,
    reportGeneration: true,
    reportExport: true,
    userLogin: true,
    userLogout: true,
    navigation: true,
    search: true,
    formSubmission: true
  },

  // Debug configuration
  debug: {
    enableLogging: process.env.NODE_ENV === 'development', // Enable in development
    logGA4Events: false,
    logGTMEvents: process.env.NODE_ENV === 'development'
  }
};

export default analyticsConfig;
